const before = '';

export default {
  'home': {
    'path': '',
    redirect: {
      name: 'public_app'
    }
  },
  // 401错误
  'error_401': {
    'path': '/401',
  },
  //404路由
  'error_404':{
    'path': '/404'
  }
}



// WEBPACK FOOTER //
// ./src/views/Common/route.config.js